import { Suspense } from 'react';
import { CalendarGrid } from './CalendarGrid';
import { CalendarHeader } from './CalendarHeader';
import { Skeleton } from '@/components/ui/skeleton';

export function Calendar() {
  return (
    <div className="grid gap-2">
      <CalendarHeader />
      <Suspense fallback={<Skeleton className="h-screen w-full" />}>
        <div className="bg-neutrals-100 rounded-xl">
          <CalendarGrid />
        </div>
      </Suspense>
    </div>
  );
}
